import Vue from 'vue';

//Языки подключенные из файлов
import uk from './lang/uk.json';
import { initializationLang } from './lang/init';



export var store = Vue.observable({
    dialogComponent: {
        opened: []
    },
    window: {
        width: 0,
        height: 0,
    },
    loader: false,
    langs: {
        uk
    },
    companyId:null,
    companyName:null,
    address:'',
    activePaymentSystem:null,
    // Юридичні відомості продавця для розділу «Оплата і повернення».
    // Приходять з getStart полем companySettings: legalType (1 — ФОП, 0 — юрособа),
    // companyName (юридична назва, не плутати з кореневим companyName для шапки),
    // fullName (ПІБ), legalAddress, phone, email, edrpou.
    // Якщо заклад їх не заповнив — null, сторінка тоді бере tradepoint.contacts.
    company:null,
    // Текст розділу «Умови користування» з getStart: { payment, delivery, refund }.
    // Перекриває дефолти з utils/termsContent.js. Тримаємо на беку, щоб текст був
    // однаковий у tpay і qr-menu і мінявся без релізу фронтів.
    terms:null,
    version: "1",
    animation: false,
    currentLang : 'uk',
    lang: initializationLang('uk'),
    setLanguage(lang) {
        this.lang = initializationLang(lang);
        this.currentLang = lang;
    }
});



